import script from "./LockScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./LockScreen.vue?vue&type=script&setup=true&lang=ts"

import "./LockScreen.vue?vue&type=style&index=0&id=7e51ea80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e51ea80"]])

export default __exports__